<template>
	<div class="group">
		<div class="cells">
			<div class="cell-title">{{name}}</div>
			<div class="cell-items">({{items.length}})</div>
			<div class="cell-sku">Varenummer</div>
			<div class="cell-price">Engrospris</div>
			<div class="cell-counter">Antal</div>
		</div>

		<div class="items">
			<item v-for="item in items" :key="item.id" v-bind="{item}"/>
		</div>
	</div>
</template>

<script>
import item from "./item/index.vue";

export default {
	components: {item},
	props: {
		items: {type: Array, required: true},
		name: {type: String, required: true}
	}
}
</script>

<style lang="scss" scoped>
.group {
	margin-bottom: em(30);

	.cells {
		> div {
			font-size: 12px;
		}

		.cell {
			&-title {
				letter-spacing: 1px;
				font-size: 16px;
				font-weight: 500;
				padding-left: 0;
			}
			&-items {
				font-size: 14px;
				font-weight: 500;
				padding-left: 0;
				margin-bottom: -2px;
			}
		}
	}

	/deep/ {
		.cells {
			width: 100%;
			display: flex;
			align-items: center;

			> div {
				padding: 16px;
			}

			.cell {
				&-items {

				}
				&-sku {
					width: 140px;
					margin-left: auto;
				}
				&-price {
					width: 130px;
				}
				&-counter {
					width: 137px;
				}
			}
		}
	}
}
</style>
